
export const HEADER_HIGHT = 80;
export const FOOTER_HIGHT = 80;
